import React from "react";
import { UnstyledModal } from "../../unstyled/modal/UnstyledModal";
import "./modal.css";
const Modal = ({
  classPrepend = "styled",
  className = "",
  title = "",
  modalIsOpen,
  close,
  clickAwayListener = false,
  children
}) => {
  return /*#__PURE__*/React.createElement(UnstyledModal, {
    classPrepend: classPrepend,
    title: title,
    modalIsOpen: modalIsOpen,
    className: className,
    close: close,
    clickAwayListener: clickAwayListener,
    children: children
  });
};
export { Modal };